/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForKubernetesCluster extends models.ServiceAccountNativeDetailsBaseForResource {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForKubernetesCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForKubernetesCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesCluster>): ServiceAccountNativeDetailsBaseForKubernetesCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForKubernetesCluster(), model);
        ServiceAccountNativeDetailsBaseForKubernetesCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesCluster>): ServiceAccountNativeDetailsBaseForKubernetesCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForKubernetesCluster.newInstance(<ServiceAccountNativeDetailsBaseForKubernetesCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForKubernetesCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForKubernetesCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.prometheus_details) {
            models.KubernetesClusterPrometheusDetails.fixupPrototype(this.prometheus_details);
        }
        if (this.storage) {
            models.StorageConfigurationBaseForKubernetes.fixupPrototype(this.storage);
        }
    }

    /**
     * Cluster Id.
     */
    cluster_id: string;

    /**
     * Cluster Name.
     */
    cluster_name: string;

    /**
     * Cluster Description if any.
     */
    cluster_description: string;

    /**
     * Kubernetes Cluster Prometheus Details
     */
    prometheus_details: models.KubernetesClusterPrometheusDetails;

    /**
     * Storage Configuration
     */
    storage: models.StorageConfigurationBaseForKubernetes;

    /**
     * Kubernetes Cluster Deployment Method.
     */
    deployment_method: models.KubernetesDeploymentMethods;

}
